import React from 'react'
import Temp from './components/temp'

const App = () => {
  return (
    <>
      <Temp/>
    </>
  )
}

export default App